/**
 * Yearly saving of the annual plan over paying monthly for 12 months, as a
 * localized whole-unit amount in the storefront currency ("$47", "47 €").
 *
 * Uses the store's own price objects, never a hardcoded figure. Rounds down so
 * the claim is never larger than the real saving. Returns null when either
 * price or the currency is missing, or the saving is not positive, so callers
 * can hide the claim instead of stating something untrue.
 */
export function formatAnnualSavings(
  annualPrice: number | null | undefined,
  monthlyPrice: number | null | undefined,
  currencyCode: string | null | undefined,
  locale?: string,
): string | null {
  if (
    typeof annualPrice !== 'number' ||
    typeof monthlyPrice !== 'number' ||
    !Number.isFinite(annualPrice) ||
    !Number.isFinite(monthlyPrice) ||
    annualPrice <= 0 ||
    monthlyPrice <= 0 ||
    !currencyCode
  ) {
    return null;
  }
  // Work in hundredths so float noise (9.99 * 12) cannot shave off a unit.
  const savingsCents = Math.round(monthlyPrice * 1200) - Math.round(annualPrice * 100);
  const wholeUnits = Math.floor(savingsCents / 100);
  if (wholeUnits <= 0) return null;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(wholeUnits);
  } catch {
    return null;
  }
}
